import React, { useState, useEffect } from 'react'
import { Wrapper, Div } from './style'

export const Difficulty = ({ pimId, name, pims, subjectId, hidden, mypageUrl, actions }) => {
  const [diff, setDiff] = useState<number | null>(null)
  const pimDifficults = pims.filter(i => i.label)

  useEffect(() => {
    setDiff(null)
  }, [subjectId])

  useEffect(() => {
    const initialPim = diff ? pimDifficults.find(i => i.difficulty === diff) : pimDifficults[0]
    
    if (initialPim) {
      actions.setPimId(initialPim.id)
      setDiff(initialPim.difficulty)
    }

  }, [subjectId, diff])

  const changeDiffHandler = e => {
    actions.setPimId(null)
    setDiff(+e.target.value)
  }

  const sortedPims = pims.filter(i => i.difficulty === diff).reduce((memo, curr, idx, arr) => {
    return curr.label 
      ? [curr, ...memo] 
      : [...memo, curr]
  }, [])

  const setPimId = e => {
    const value = +e.target.value
    const selectPim = sortedPims.find(i => i.id === value)

    if (selectPim.label) {
      return actions.setPimId(value, false)
    }

    actions.setPimId(value, true)
  }

  return (
    <Wrapper $hidden={hidden}>
      <label>Трудоемкость</label>
      <select name="diffLevel" id="diffLevel" className="form-control" onChange={changeDiffHandler}>
        {pimDifficults.map(i => <option value={i.difficulty} key={i.id}>{i.label}</option>)}
      </select>
      <Div>
        <a
          href={`${mypageUrl}/demo_test.php?oopkodes=fgos&pimid=${pimId}&subjname=${name}`}
          target="_blank"
        >
          Демонстрационный вариант ПИМ
        </a>
      </Div>
      <label>Структура теста</label>
      <select name="diffLevel" id="diffLevel" className="form-control" onChange={setPimId}>
        {sortedPims.map(i => (
          <option
            key={i.id}
            value={i.id}
          >
            {i.label ? 'без конструирования' : 'с конструированием'}
          </option>
        ))}
      </select>
    </Wrapper>
  )
}
